<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CS963-printer">
     CS963-printer
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_nl" title="Informatie over veiligheid">
     Informatie over veiligheid
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Conventies">
      Conventies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e43" title="Productverklaringen">
      Productverklaringen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_nl" title="Over de printer">
     Over de printer
    </a>
   </p>
   <div id="divd0e213">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_nl" title="Informatie zoeken over de printer">
      Informatie zoeken over de printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_nl" title="Het serienummer van de printer zoeken">
      Het serienummer van de printer zoeken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_nl" title="Printerconfiguraties">
      Printerconfiguraties
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_nl" title="Het bedieningspaneel gebruiken">
      Het bedieningspaneel gebruiken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_nl" title="Pictogrammen van beginscherm">
      Pictogrammen van beginscherm
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_nl" title="Kleuren van het indicatielampje">
      Kleuren van het indicatielampje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_nl" title="De beveiligingssleuf vinden">
      De beveiligingssleuf vinden
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e715" title="Papier selecteren">
      Papier selecteren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10486" title="Aanvullende printerfuncties en ondersteuning">
      Aanvullende printerfuncties en ondersteuning
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_nl" title="Installeren, instellen en configureren">
     Installeren, instellen en configureren
    </a>
   </p>
   <div id="divd0e10604">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_nl" title="Een locatie voor de printer selecteren">
      Een locatie voor de printer selecteren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_nl" title="Printerpoorten">
      Printerpoorten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#d0e10784" title="Apps en oplossingen configureren">
      Apps en oplossingen configureren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e10942" title="De toegankelijkheidsfuncties instellen en gebruiken">
      De toegankelijkheidsfuncties instellen en gebruiken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_nl" title="Papier en speciaal afdrukmateriaal plaatsen">
      Papier en speciaal afdrukmateriaal plaatsen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e11648" title="Software, stuurprogramma's en firmware installeren en bijwerken">
      Software, stuurprogramma's en firmware installeren en bijwerken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e11951" title="Hardwareopties installeren">
      Hardwareopties installeren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e13431" title="Netwerkfunctionaliteit">
      Netwerkfunctionaliteit
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="secure-printer-chapter.html#secure-printer-chapter_nl" title="Printer beveiligen">
     Printer beveiligen
    </a>
   </p>
   <div id="divd0e13782">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_nl" title="Printergeheugen wissen">
      Printergeheugen wissen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_nl" title="Opslagstation van printer wissen">
      Opslagstation van printer wissen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_nl" title="Fabrieksinstellingen herstellen">
      Fabrieksinstellingen herstellen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_nl" title="Kennisgeving van vluchtigheid">
      Kennisgeving van vluchtigheid
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_nl" title="Afdrukken">
     Afdrukken
    </a>
   </p>
   <div id="divd0e13972">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_nl" title="Afdrukken vanaf een computer">
      Afdrukken vanaf een computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14023" title="Afdrukken vanaf een mobiel apparaat">
      Afdrukken vanaf een mobiel apparaat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_nl" title="Afdrukken vanaf een flashstation">
      Afdrukken vanaf een flashstation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_nl" title="Beveiligde taken configureren">
      Beveiligde taken configureren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_nl" title="Afdrukken van vertrouwelijke taken en andere onderbroken taken">
      Afdrukken van vertrouwelijke taken en andere onderbroken taken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_nl" title="Lijst met voorbeelden van lettertypen afdrukken">
      Lijst met voorbeelden van lettertypen afdrukken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_nl" title="Een directorylijst afdrukken">
      Een directorylijst afdrukken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_nl" title="Scheidingsvellen toevoegen in afdruktaken">
      Scheidingsvellen toevoegen in afdruktaken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_nl" title="Afdruktaak annuleren">
      Afdruktaak annuleren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_nl" title="Tonerintensiteit aanpassen">
      Tonerintensiteit aanpassen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_nl" title="Printermenu's">
     Printermenu's
    </a>
   </p>
   <div id="divd0e14518">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_nl" title="Menu-overzicht">
      Menu-overzicht
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e14826" title="Apparaat">
      Apparaat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e16736" title="Afdrukken">
      Afdrukken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e18017" title="Papier">
      Papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e18294" title="USB-station">
      USB-station
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e18558" title="Netwerk/poorten">
      Netwerk/poorten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e20680" title="Beveiliging">
      Beveiliging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e21744" title="Cloud Services">
      Cloud Services
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e21801" title="Rapporten">
      Rapporten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_nl" title="Problemen oplossen">
      <strong>
       Problemen oplossen
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_nl" title="Forms Merge">
      <strong>
       Forms Merge
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_nl" title="De Pagina met menu-instellingen afdrukken">
      De
      <strong>
       Pagina met menu-instellingen
      </strong>
      afdrukken
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_nl" title="Afwerkingsopties voor printer">
     Afwerkingsopties voor printer
    </a>
   </p>
   <div id="divd0e22189">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_nl" title="De nietfinisher gebruiken">
      De nietfinisher gebruiken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_nl" title="De finisher met niet- en perforeerfunctie gebruiken">
      De finisher met niet- en perforeerfunctie gebruiken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_nl" title="De gescheiden uitvoerlader gebruiken">
      De gescheiden uitvoerlader gebruiken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_nl" title="De boekjesfinisher gebruiken">
      De boekjesfinisher gebruiken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_nl" title="De optie papiertransport met vouwen gebruiken">
      De optie papiertransport met vouwen gebruiken
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_nl" title="Printer onderhouden">
     Printer onderhouden
    </a>
   </p>
   <div id="divd0e22598">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_nl" title="De status van de onderdelen en supplies controleren">
      De status van de onderdelen en supplies controleren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_nl" title="Meldingen over supplies configureren">
      Meldingen over supplies configureren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_nl" title="Meldingen via e-mail instellen">
      Meldingen via e-mail instellen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_nl" title="Rapporten en logboeken genereren">
      Rapporten en logboeken genereren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_nl" title="Onderdelen en supplies bestellen">
      Onderdelen en supplies bestellen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e23197" title="Onderdelen en supplies vervangen">
      Onderdelen en supplies vervangen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e23786" title="Printeronderdelen reinigen">
      Printeronderdelen reinigen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e23900" title="Energie en papier besparen">
      Energie en papier besparen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_nl" title="De printer verplaatsen naar een andere locatie">
      De printer verplaatsen naar een andere locatie
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_nl" title="Problemen oplossen">
     Problemen oplossen
    </a>
   </p>
   <div id="divd0e24035">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_nl" title="Problemen met de afdrukkwaliteit">
      Problemen met de afdrukkwaliteit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_nl" title="Printerfoutcodes">
      Printerfoutcodes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e25210" title="Afdrukproblemen">
      Afdrukproblemen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_nl" title="De printer reageert niet">
      De printer reageert niet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_nl" title="Flashstation kan niet worden gelezen">
      Flashstation kan niet worden gelezen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_nl" title="USB-poort activeren">
      USB-poort activeren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_nl" title="Papierstoringen verhelpen">
      Papierstoringen verhelpen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e27191" title="Problemen met de netwerkverbinding">
      Problemen met de netwerkverbinding
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e27282" title="Problemen met hardwareopties">
      Problemen met hardwareopties
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e27450" title="Problemen met supplies">
      Problemen met supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e27598" title="Problemen met de papierinvoer">
      Problemen met de papierinvoer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e27792" title="Problemen met kleurkwaliteit">
      Problemen met kleurkwaliteit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_nl" title="Contact opnemen met de klantenondersteuning">
      Contact opnemen met de klantenondersteuning
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_nl" title="Recyclen en wegdoen">
     Recyclen en wegdoen
    </a>
   </p>
   <div id="divd0e28016">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_nl" title="Lexmark-producten recyclen">
      Lexmark-producten recyclen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_nl" title="Lexmark-verpakkingsmateriaal recyclen">
      Lexmark-verpakkingsmateriaal recyclen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_nl" title="Kennisgevingen">
     Kennisgevingen
    </a>
   </p>
   <div id="divd0e28050">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28053" title="Productinformatie">
      Productinformatie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28070" title="Uitgavebericht">
      Uitgavebericht
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_nl" title="Handelsmerken">
      Handelsmerken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_nl" title="Licentiemeldingen">
      Licentiemeldingen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_nl" title="Geluidsniveaus">
      Geluidsniveaus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_nl" title="AEEA-richtlijn (Afgedankte elektrische en elektronische apparatuur)">
      AEEA-richtlijn (Afgedankte elektrische en elektronische apparatuur)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28168" title="Oplaadbare lithium-ionbatterij">
      Oplaadbare lithium-ionbatterij
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_nl" title="Verordening (EU) 2023/1542">
      Verordening (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28205" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_nl" title="Verwijdering van het product">
      Verwijdering van het product
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_nl" title="Lexmark cartridges terugsturen voor hergebruik of recycling">
      Lexmark cartridges terugsturen voor hergebruik of recycling
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_nl" title="Kennisgeving over gevoeligheid voor statische elektriciteit">
      Kennisgeving over gevoeligheid voor statische elektriciteit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_nl" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_nl" title="Temperatuurinformatie">
      Temperatuurinformatie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_nl" title="Laserinformatie">
      Laserinformatie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_nl" title="Stroomverbruik">
      Stroomverbruik
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28466" title="Kennisgevingen over regelgevingen voor draadloze producten">
      Kennisgevingen over regelgevingen voor draadloze producten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_nl" title="Kennisgeving over modulaire componenten">
      Kennisgeving over modulaire componenten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_nl" title="Blootstelling aan hoogfrequentie-energie">
      Blootstelling aan hoogfrequentie-energie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28491" title="Voorschriften van de Europese Gemeenschap (EG)">
      Voorschriften van de Europese Gemeenschap (EG)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_nl" title="Voorschriften van de Europese Gemeenschap (EG)">
      Voorschriften van de Europese Gemeenschap (EG)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_nl" title="Kennisgeving van radiostoring">
      Kennisgeving van radiostoring
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue